var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div__datepicker_row"},[_vm._t("default"),_c('date-picker',{attrs:{"type":"date","lang":_vm.lang},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }